import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/axios';
import { MdArticle, MdPeople, MdCampaign, MdVisibility, MdTrendingUp, MdAddCircle } from 'react-icons/md';

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/admin/analytics/overview')
      .then(res => setStats(res.data.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="page-loader">Loading...</div>;

  const cards = [
    { label: 'Articles Today', value: stats?.articlesToday || 0, icon: MdArticle, color: '#DC2626' },
    { label: 'Active Ads', value: stats?.activeAds || 0, icon: MdCampaign, color: '#F59E0B' },
    { label: 'Total Users', value: stats?.totalUsers || 0, icon: MdPeople, color: '#10B981' },
    { label: 'Reads Today', value: stats?.readsToday || 0, icon: MdVisibility, color: '#6366F1' },
    { label: 'Guest Devices', value: stats?.totalGuests || 0, icon: MdTrendingUp, color: '#8B5CF6' },
  ];

  return (
    <div className="page">
      <div className="page-header">
        <h2>Dashboard</h2>
        <Link to="/articles/new" className="btn btn-primary">
          <MdAddCircle /> Publish Article
        </Link>
      </div>

      <div className="stats-grid">
        {cards.map((card, i) => (
          <div key={i} className="stat-card">
            <div className="stat-icon" style={{ background: card.color + '15', color: card.color }}>
              <card.icon />
            </div>
            <div className="stat-info">
              <h3>{card.value}</h3>
              <p>{card.label}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="quick-links">
        <h3>Quick Actions</h3>
        <div className="link-grid">
          <Link to="/articles/new" className="quick-card">
            <MdAddCircle /> Publish New Article
          </Link>
          <Link to="/articles" className="quick-card">
            <MdArticle /> Manage Articles
          </Link>
          <Link to="/ads" className="quick-card">
            <MdCampaign /> Manage Ads
          </Link>
          <Link to="/analytics" className="quick-card">
            <MdTrendingUp /> View Analytics
          </Link>
        </div>
      </div>
    </div>
  );
}
